<template>
  <Wrapper>
    <Topo v-if="isMobile" />
    <LoginMain>
      <v-card
        color="transparent"
        outlined="outlined"
        :max-width="isMobile ? '400px' : '585px'"
        :class="isMobile ? 'mx-auto' : ''"
      >
        <LoginTitulo>
          <template v-slot:titulo>
            {{ tituloDaPagina }}
          </template>
          <template v-slot:subtitulo>
            {{ subtituloPagina }}
          </template>
        </LoginTitulo>

        <v-form @submit.prevent="forgotMyPassword">
          <v-col class="my-0 pa-0">
            <v-text-field
              v-model="email"
              type="email"
              label="E-mail"
              filled
              required
              background-color="#FFF"
              data-cy="input_email"
              :error-messages="errorMessagesEmail"
            />

            <v-btn
              color="primary"
              dark
              data-cy="button_solicitarAlteracao"
              type="submit"
              :absolute="isDesktop"
              :block="isMobile"
              :class="isDesktop ? 'btn-alterar-desktop' : ''"
              :loading="loading"
            >
              Solicitar alteração
            </v-btn>
          </v-col>
        </v-form>

        <SnackBar
          :mensage="validationMessage"
          :snackbar="invalidCredentials"
          @changeSnackBar="snackbarVisible => invalidCredentials = snackbarVisible.visible"
        />

        <v-btn
          class="primary--text mt-3 mt-md-0"
          color="primary"
          data-cy="button-back"
          outlined
          to="/login"
          :absolute="isDesktop"
          :block="isMobile"
          :class="isDesktop ? 'btn-voltar-desktop' : ''"
        >
          Voltar
        </v-btn>
      </v-card>
    </LoginMain>
    <Rodape
      :exibe-central="true"
    />
  </Wrapper>
</template>

<script>

import { required, email } from 'vuelidate/lib/validators';
import ApiAuth from '@/api/auth';
import Wrapper from '../components/Wrapper.vue';
import LoginMain from '../components/Login/LoginMain.vue';
import LoginTitulo from '../components/Login/LoginTitulo.vue';
import Topo from '../components/Topo.vue';
import Rodape from '../components/Rodape.vue';
import SnackBar from '../components/SnackBar.vue';

export default {
  name: 'ForgotMyPassword',

  components: {
    Wrapper,
    LoginTitulo,
    LoginMain,
    Topo,
    Rodape,
    SnackBar,
  },

  data() {
    return {
      show1: false,
      show2: false,
      email: '',
      outlined: false,
      loading: false,
      invalidCredentials: false,
      invalidEmail: false,
      validationMessage: '',
      success: false,
      type: 'success',
      emailSuccess: '',
      invalidEmailMessage: ['Por favor, informe um e-mail válido.'],
      tituloDaPagina: 'Não sabe ou esqueceu a sua senha?',
      subtituloPagina: 'É só digitar no campo abaixo o mesmo e-mail utilizado na sua compra.',
      genericErrorMessage: 'Ocorreu um erro.',
      connectionErrorMessage: 'Ocorreu um erro. Por favor, tente novamente mais tarde.',
    };
  },

  validations: {
    email: {
      required,
      email: (value, vm) => value.indexOf('@-') === -1 && email(value, vm),
    },
  },

  computed: {
    isDesktop() {
      return this.$vuetify.breakpoint.mdAndUp;
    },

    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },

    errorMessagesEmail() {
      if (this.$v.email.$dirty && this.$v.email.$invalid) {
        return this.invalidEmailMessage;
      }

      return [];
    },
  },

  methods: {
    async forgotMyPassword() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      const formData = new FormData();
      formData.set('login', this.email);
      this.loading = true;

      try {
        const data = await ApiAuth.sendRecoverLink(formData);

        if (!data) {
          throw new Error(this.genericErrorMessage);
        }

        this.success = true;
        this.emailSuccess = this.email;
        this.$store.dispatch('setEmailSuccess', this.emailSuccess);
        this.$router.push('/confirmacao-email-enviado');
      } catch (error) {
        this.invalidCredentials = true;
        this.validationMessage = this.connectionErrorMessage;
      }

      this.loading = false;
    },
  },
};
</script>

<style scoped lang="scss">
.btn-alterar-desktop {
  right: 0;
  width: calc(50% - 15px);
}
.btn-voltar-desktop {
  width: calc(50% - 15px);
}
</style>
